export const EMERGENCY_RELATIONSHIP_OPTIONS = [
  "Prindi",
  "Bashkëshorti/ja",
  "Motra/Vëllai",
  "Fëmija",
  "Mik/Mikeshë",
];

export const emergencyContactDynamicFields = [
  {
    formItemName: "fullName",
    label: "Emri i plotë",
    placeholder: "Emri i plotë",
    type: "Input",
    disabled: false,
    rules: [
      {
        required: true,
        message: "Ju lutem shkruani emrin e plotë",
      },
    ],
  },
  {
    formItemName: "email",
    label: "Email",
    type: "Email",
    disabled: false,
    rules: [
      {
        required: true,
        type: "email",
        message: "Formati i email nuk është i saktë!",
      },
    ],
  },
  {
    formItemName: "phoneNumber",
    label: "Numri i telefonit",
    type: "PhoneNumber",
    rules: [
      {
        required: true,
        message: "Ju lutem shkruani numrin e telefonit!",
      },
    ],
    disabled: false,
  },
  {
    formItemName: "relationship",
    label: "Lidhja me personin",
    type: "ComboBox",
    options: EMERGENCY_RELATIONSHIP_OPTIONS,
    disabled: false,
    rules: [
      {
        required: true,
        message: "Ju lutem zgjidhni marrëdhënien tuaj me personin",
      },
    ],
  },
];

export const emptyEmergencyContact = () => ({
  fullName: "",
  email: "",
  phoneNumber: "",
  relationship: "",
});

/** Normalize legacy string / object / array shapes into a non-empty array of contacts. */
export const normalizeEmergencyContacts = (value) => {
  if (Array.isArray(value)) {
    return value.length > 0 ? value : [emptyEmergencyContact()];
  }
  if (typeof value === "string" && value.trim()) {
    return [
      {
        ...emptyEmergencyContact(),
        phoneNumber: value.replace(/^\+/, ""),
      },
    ];
  }
  if (value && typeof value === "object") {
    return [value];
  }
  return [emptyEmergencyContact()];
};

export const formatEmergencyContactsDisplay = (value) => {
  const rows = normalizeEmergencyContacts(value).filter(
    (row) =>
      row?.fullName || row?.email || row?.phoneNumber || row?.relationship
  );
  if (!rows.length) return "—";

  return rows
    .map((row, index) => {
      const parts = [
        row.fullName,
        row.relationship,
        row.phoneNumber,
        row.email,
      ].filter(Boolean);
      return `${index + 1}. ${parts.join(" · ")}`;
    })
    .join("\n");
};

export const emergencyContactRequiredRule = {
  validator: async (_, value) => {
    const rows = Array.isArray(value) ? value : value ? [value] : [];
    const validRows = rows.filter(
      (row) =>
        row?.fullName?.trim() &&
        row?.email?.trim() &&
        row?.phoneNumber?.toString()?.trim() &&
        row?.relationship?.trim()
    );
    if (!validRows.length) {
      throw new Error(
        "Ju lutem plotësoni të paktën një kontakt emergjence të plotë"
      );
    }
  },
};
